import { Message } from "./Message";
import { OptionSet } from "./OptionSet";

export class DashboardData{
    DataQuentity : Array<OptionSet>;
    Messages : Array<Message>;    
}